<template>
  <div class="head">
    <el-form class="form" :model="liveForm" size="small" label-width="80px">
      <el-form-item label="选择直播：">
        <load-select
          class="select"
          v-model="liveForm.liveId"
          dictLabel="name"
          dictValue="uuid"
          :data="liveData"
          :page="livePage"
          :hasMore="liveMore"
          :request="getLiveData"
          placeholder="请选择直播（输入名称以搜索）"
          :defaultVal="liveForm.liveName"
          :isInit="isLiveInit"
          @change="liveChange"
          @ChangeValue="changeLive"
        />
      </el-form-item>
    </el-form>
    <div class="top-right" v-if="!!this.liveForm.liveId">
      <CountDownBtn @refresh="refresh" />
      <butn btntype="primary" v-permission="'liveRoomStats:export'" title="导出" @click.native="exportExcel"> </butn>
    </div>
  </div>
</template>
<script>
import butn from "@/components/button/index";
import CountDownBtn from "./countDownBtn.vue";
import LoadSelect from "@/components/load-select/index.vue";
import { getLiveRoomSelectPage } from "@/api/liveRoom";
import { ioRead } from "@/utils/common.js";
import { liveRoomStatsExport } from "@/api/resourceService";
export default {
  components: { butn, LoadSelect, CountDownBtn},
  data() {
    return {
      liveForm: {
        liveId: "",
        liveName: "",
      },
      liveData: [],
      liveMore: true,
      isLiveInit: true,
      livePage: 1,
    };
  },
  created() {
    this.getLiveData();
  },
  activated() {},
  computed: {},
  methods: {
    // 直播统计导出
    exportExcel() {
      if (!!this.liveForm.liveId) {
        liveRoomStatsExport(this.liveForm.liveId).then((response) =>
          ioRead(response)
        );
      } else {
        this.$message.error("请先选择直播！");
      }
    },
    // 直播变更重新发起查询统计请求
    liveChange(e) {
      this.isLiveInit = false;
    },
    refresh() {
      this.$emit('refresh')
    },
    changeLive(val) {
      let liveRoomId = null
      let startTime = null
      if (!!val) {
        let item = this.liveData.filter((item) => item.uuid == val)[0];
        this.liveForm.liveId = item.uuid;
        this.liveForm.liveName = item.name;
        liveRoomId = item.uuid;
        startTime = item.startDateStr
      } 
      this.$emit('selectLiveRomm', {
        liveRoomId,
        startTime
      })
    },
    getLiveData({ page = 1, more = false, keyword = "" } = {}) {
      return new Promise((resolve) => {
        getLiveRoomSelectPage({ page, name: keyword })
          .then(({ code, data }) => {
            if (code !== 0) return;
            if (more) {
              this.liveData = [...this.liveData, ...data.records];
            } else {
              this.liveData = data.records;
            }
            let { current, total, size } = data;
            this.liveMore = this.liveData.length < total;
            this.livePage = current;
            resolve();
          })
          .catch((_) => {
            resolve();
          });
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.head {
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.form {
  .select {
    width: 500px;
  }
}
</style>